import { Card, CardContent, Grid, TextField, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import { cloneDeep, debounce } from "lodash";
import React, { useEffect, useRef, useState } from "react";
import { IComboBoxOption, IContractVariation, IContractVariationProps } from "../../interfaces";
import { FormSectionHeader } from "../Shared/FormSectionHeader";

export const ContractVariationDetailForm: React.FC<IContractVariationProps> = ({
    contractVariation,
    updateVariation,
    readonly,
    ...props
}) => {


    const [variationModel, setVariationModel] = useState(contractVariation);
    const [unsavedChanges, setUnsavedChanges] = useState(false);


    const handleChange = (property: string, value: string | IComboBoxOption | boolean | null) => {


        setUnsavedChanges(true);
        var newModel;

        setVariationModel((prevModel) => {
            newModel = cloneDeep(prevModel) as any;
            newModel[property] = value;

            handleSaveDebounced(null, newModel);

            return newModel as IContractVariation;
        })

    }

    const handleSave = (e?: any, model?: IContractVariation | undefined) => {
        updateVariation(cloneDeep(model ? model : variationModel) as IContractVariation);
        setUnsavedChanges(false);
    }
    const handleSaveDebounced = useRef(debounce(handleSave, 1000)).current;

    useEffect(() => {
        if (variationModel !== contractVariation) {
            setVariationModel(contractVariation)
        }
    }, [contractVariation])


    return (

        <Grid container spacing={2}>

            <Grid item xs={8}>
                <Card sx={{ height: "100%" }} >

                    <FormSectionHeader label="Variation Details" saving={unsavedChanges} />

                    <CardContent>

                        <Grid container spacing={2}>

                            <Grid item xs={6}>
                                <ToggleButtonGroup
                                    value={contractVariation.isContractEnd === true ? "end" : "update"}
                                    exclusive
                                    onChange={(e, value) => readonly ? {} : handleChange("isContractEnd", value === "end" ? true : false)}
                                >
                                    <ToggleButton color="primary" value="update" disabled={readonly}>Update Contract</ToggleButton>
                                    <ToggleButton color="error" value="end" disabled={readonly}>End Contract</ToggleButton>
                                </ToggleButtonGroup>
                            </Grid>


                            <Grid item xs={6}>
                                {
                                    !contractVariation.isContractEnd &&
                                    <TextField
                                        fullWidth
                                        variant="outlined"
                                        label="CV Number"
                                        value={variationModel.cvNumber}
                                        onChange={(e) => handleChange("cvNumber", e.currentTarget.value)}
                                        helperText="contract variation number from Delphi"
                                        disabled={readonly}
                                        required
                                    />
                                }
                            </Grid>


                            <Grid item xs={12} >
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    multiline
                                    rows={3}
                                    label="Reason for Variation"
                                    value={variationModel.contractVariationReason}
                                    onChange={(e) => handleChange("contractVariationReason", e.currentTarget.value)}
                                    helperText="Why is the variation to contract / lease spare list required"
                                    disabled={readonly}
                                    required
                                />
                            </Grid>


                        </Grid>


                    </CardContent>
                </Card>

            </Grid>

            <Grid item xs={4}>
                <Card sx={{ height: "100%" }} >

                    <FormSectionHeader label="Contract / Lease Details" />

                    <CardContent>
                        {contractVariation.contract &&

                            <Grid item xs={12}>

                                <Typography variant="subtitle2">
                                    <strong>Reference:</strong> {contractVariation.contract.reference}
                                </Typography>
                                <Typography variant="subtitle2" display="flex" >
                                    <Grid item xs={6} ><strong>Contract Start:</strong> {contractVariation.contract.startDate && new Date(contractVariation.contract.startDate).toLocaleDateString("en-GB")}</Grid>
                                    <Grid item xs={6}><strong>Contract End:</strong> {contractVariation.contract.endDate && new Date(contractVariation.contract.endDate).toLocaleDateString("en-GB")}</Grid>
                                </Typography>
                                <Typography variant="subtitle2" display="flex">
                                    <Grid item xs={6}><strong>Last Audit:</strong> {contractVariation.contract.lastAudit && new Date(contractVariation.contract.lastAudit).toLocaleDateString("en-GB")}</Grid>
                                    <Grid item xs={6}><strong> Next Audit:</strong> {contractVariation.contract.nextAudit && new Date(contractVariation.contract.nextAudit).toLocaleDateString("en-GB")}</Grid>
                                </Typography>
                                <Typography variant="subtitle2">
                                    <strong>Procurement Manager:</strong> {contractVariation.contract.contractManager?.value}
                                </Typography>
                                <Typography variant="subtitle2">
                                    <strong>Commercial Manager:</strong> {contractVariation.contract.categoryManager?.value}
                                </Typography>

                            </Grid>

                        }

                    </CardContent>
                </Card>

            </Grid>
        </Grid>
    );
}